import { render, staticRenderFns } from "./organisationSettings.vue?vue&type=template&id=9d0ed30e&scoped=true"
import script from "./organisationSettings.vue?vue&type=script&lang=js"
export * from "./organisationSettings.vue?vue&type=script&lang=js"
import style0 from "./organisationSettings.vue?vue&type=style&index=0&id=9d0ed30e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0ed30e",
  null
  
)

export default component.exports